import { render, staticRenderFns } from "./EditChargesDialog.vue?vue&type=template&id=ca3a3510"
import script from "./EditChargesDialog.vue?vue&type=script&lang=js"
export * from "./EditChargesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports